import { alpha, Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

const genericListsStyles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
    },

    table: {
        "& img": {
            width: 24,
            height: 24
        },
        "& td:nth-child(3)": {
            paddingLeft: "8px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 0
        }
    },

    tableContainer: {
        height: "400px",
        overflow: 'auto',
    },

    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing(),
        paddingRight: theme.spacing(),
        paddingBottom: theme.spacing(),
        paddingLeft: theme.spacing(10),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },

    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.grey[500], 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.grey[500], 0.25),
        },
        marginBottom: theme.spacing(),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing(9),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default genericListsStyles;
